export default "__VITE_ASSET__81ec94bb__"